export default "__VITE_ASSET__490c9b85__"